import Vue from 'vue';
import { ActionTree } from 'vuex';
import { ContractState } from './state';
import RootState from '@/store/root_state';
import { MicroserviceEnum, mutation, query } from '@/helpers/westeros';
import {
  getContractHtml,
  GetContractHtmlQueryResult,
} from '@/store/graphql/queries/westerosArcaneumQueries';
import {
  generateContract,
  GenerateContractMutationResult,
} from '@/store/graphql/mutations/westerosArcaneumMutations';

const actions: ActionTree<ContractState, RootState> = {
  async ACCEPT_CONTRACT({ dispatch }): Promise<void> {
    await dispatch('UPSERT_ENROLLMENT', { isContractAccepted: true });
  },

  async PULL_CONTRACT_HTML({ commit }): Promise<void> {
    const { data } = await query<GetContractHtmlQueryResult>(
      MicroserviceEnum.ARCANEUM,
      getContractHtml,
    );

    const html = (data.getEnrollment.backofficeContractHtml || '').replace(/\t/g, '');

    commit('SET_CONTRACT_HTML', html);
  },

  async GENERATE_CONTRACT(): Promise<void> {
    const authToken = Vue.$cookies.get('admissions-auth-token');

    if (!authToken) throw new Error('Forbidden');

    await mutation<GenerateContractMutationResult>(MicroserviceEnum.ARCANEUM, generateContract);
  },
};

export default actions;
